import pinIdleSvg from 'src/assets/pin-idle.raw.svg';
import SvgMarker from './SvgMarker';

export default class IdleSvgMarker extends SvgMarker {
  constructor() {
    super(pinIdleSvg, {
      height: 60,
      width: 60,
      innerColor: '#000',
      outerColor: '#21BA45', // TODO: replace these with Quasar variables
    });
  }
}
